import { addStateReset } from "common/reducer/addStateReset";
import { AuthenticationType } from "domains/authentication/actionTypes";

export const addUnauthenticatedReset = addStateReset(AuthenticationType.LOGOUT);
